import React from 'react';
import { BarChart, Bar, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer, LabelList } from 'recharts';

const VendorPerformanceBar = ({ data = [] }) => {
  const chartData = Array.isArray(data)
    ? data.map((item) => ({
        fullLabel: item?.label || 'Unknown Vendor',
        label: (item?.label || 'Unknown Vendor').length > 14
          ? `${(item?.label || 'Unknown Vendor').slice(0, 14)}...`
          : (item?.label || 'Unknown Vendor'),
        value: Number(item?.totalRevenue || 0),
        totalLeadsBought: Number(item?.totalLeadsBought || 0)
      })).filter((item) => item.value >= 0)
    : [];

  return (
    <div className="rounded-2xl bg-white shadow-sm border border-gray-100 p-4 h-[360px]">
      <div className="mb-4">
        <h3 className="text-sm font-semibold text-gray-900">Vendor Performance</h3>
      </div>
      {chartData.length ? (
        <ResponsiveContainer width="100%" height="88%">
          <BarChart data={chartData} margin={{ top: 10, right: 16, left: 0, bottom: 50 }}>
            <CartesianGrid stroke="#f1f5f9" strokeDasharray="3 3" />
            <XAxis
              dataKey="label"
              interval={0}
              angle={-25}
              textAnchor="end"
              height={60}
              tick={{ fontSize: 10, fill: '#64748b' }}
            />
            <YAxis tick={{ fontSize: 11, fill: '#64748b' }} />
            <Tooltip
              labelFormatter={(_, payload) => {
                const vendorName = payload?.[0]?.payload?.fullLabel || '';
                const leadsBought = payload?.[0]?.payload?.totalLeadsBought ?? 0;
                return `${vendorName} (Leads Bought: ${leadsBought})`;
              }}
              formatter={(value) => [`${value}`, 'Revenue']}
              contentStyle={{ borderRadius: '10px' }}
            />
            <Bar dataKey="value" fill="#f59e0b" radius={[8, 8, 0, 0]} barSize={26} minPointSize={4} animationDuration={700}>
              <LabelList dataKey="value" position="top" style={{ fill: '#475569', fontSize: 10 }} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <div className="h-[85%] flex items-center justify-center text-sm text-gray-400">No vendor data available</div>
      )}
    </div>
  );
};

export default VendorPerformanceBar;
